import type { NotificationAsyncDeleteSuccessDescriptionProps } from "./notification-async-delete-success-description.type";

import { Trans } from "react-i18next";

import { getNotificationParams } from "./notification-async-delete-success-description.helper";

export const NotificationAsyncDeleteSuccessDescription = ({
  data,
}: NotificationAsyncDeleteSuccessDescriptionProps) => {
  const { i18nKey, modelNames, count } = getNotificationParams(data);

  return (
    <Trans
      i18nKey={i18nKey}
      values={{ modelName: modelNames, count }}
      components={{ strong: <strong />, em: <em /> }}
    />
  );
};
